import api from '@/utils/axios';

const unwrap = (response, fallbackMessage) => {
  if (!response.data?.success) {
    const err = new Error(response.data?.error?.message || fallbackMessage);
    err.code = response.data?.error?.code;
    throw err;
  }
  return response.data.data;
};

/** Fleet dashboard stats (GAS api_getStats parity). */
export const fetchDashboardStats = async () => {
  const response = await api.post('dashboard/stats', {});
  return unwrap(response, 'Failed to load dashboard stats');
};

/** Recent activity feed (GAS api_getActivityFeed parity). */
export const fetchDashboardActivityFeed = async (limit = 20) => {
  const response = await api.post('dashboard/activityFeed', { limit });
  const data = unwrap(response, 'Failed to load activity feed');
  return data?.rows || [];
};
